import parent from '../path';

export const addNewsletter = `${parent}/newsletter/new`;

export const newsletter = `${parent}/newsletter/:id`;

export const editNewsletter = `${parent}/newsletter/:id/edit`;

export default newsletter;
